import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  imports: [TranslatePipe],
})
export class AccessDeniedComponent implements OnInit {
  private readonly _route: ActivatedRoute = inject(ActivatedRoute)
  // `history.state` set by the error interceptor, or the `state` route parameter (a string, without message)
  private readonly _state: { message?: string } | undefined =
    this._route.snapshot.paramMap.get('state') || window.history.state
  /** Set in `ngOnInit`, which runs before the template first reads it. */
  message!: string

  ngOnInit(): void {
    this.message = `USER_ERROR.${this._state?.message ?? ''}`
  }
}
